import { render, staticRenderFns } from "./JobPageCargoInfoPopup.vue?vue&type=template&id=6b25f55c&scoped=true&"
import script from "./JobPageCargoInfoPopup.vue?vue&type=script&lang=js&"
export * from "./JobPageCargoInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./JobPageCargoInfoPopup.vue?vue&type=style&index=0&id=6b25f55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b25f55c",
  null
  
)

export default component.exports